<script setup lang="ts"></script>

<template>
  <div>
    <router-view />
  </div>
</template>
